import { render, staticRenderFns } from "./CancellationSectionFeedback.vue?vue&type=template&id=4254e893"
import script from "./CancellationSectionFeedback.vue?vue&type=script&lang=js"
export * from "./CancellationSectionFeedback.vue?vue&type=script&lang=js"
import style0 from "./CancellationSectionFeedback.vue?vue&type=style&index=0&id=4254e893&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports